import Project1 from "./projectslist";

export default function Projects() {
  return (
    <div id="Project" className="mt-5 text-center text-yellow-500 pb-32">
      <h1 className="font-bold text-6xl ">
        Some Works
      </h1>
      <br />
      <Project1/>
    </div>
  );
}
